export default class ProgressButton extends HTMLButtonElement {

    connectedCallback() {

        if (!this.dataset.defaultText && this.hasChildNodes && this.childNodes[0].nodeType == 3) {
            this.dataset.defaultText = this.childNodes[0].textContent.trim();
        }

    }

    trigger() {
        this.disabled = true;

        if (this.dataset.progressText && this.hasChildNodes && this.childNodes[0].nodeType == 3) {
            this.childNodes[0].textContent = this.dataset.progressText;
        }
    }

    reset() {
        this.disabled = false;

        if (this.dataset.defaultText && this.hasChildNodes && this.childNodes[0].nodeType == 3) {
            this.childNodes[0].textContent = this.dataset.defaultText;
        }
    }

    hasIcon() {
        this.querySelector("svg") != null;
    }

}

customElements.define("progress-button", ProgressButton, { extends: 'button' });